import { styled } from "styled-components";

export const InfoContainer = styled.div``;
export const InfoFlexWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;
export const InfoWrapper = styled.div`
  padding: 60px 0 60px;
  @media all and (max-width: 768px) {
    padding: 9.115vw 0;
  }
`;

export const InfoWrap = styled.div`
  display: flex;
  gap: 60px;
  .img-wrap {
    width: 400px;
    img {
      width: 100%;
    }
  }
  .info-wrap {
    padding-top: 40px;
    flex: 1;
    .title-wrap {
      display: flex;
      flex-direction: column;
      gap: 8px;
      align-items: flex-start;
      margin-bottom: 40px;
      p {
        font-size: 32px;
        line-height: 1.3;
        color: #555;
        font-weight: bold;
      }
      h6 {
        font-size: 48px;
        line-height: 1.2;
        color: #242424;
        font-weight: bold;
      }
    }
    .icon-wrap {
      display: flex;
      gap: 16px;
      margin-bottom: 64px;
      a {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 68px;
        height: 68px;
        border-radius: 34px;
        background-color: #171717;
        img {
          width: 38px;
          height: 38px;
        }
      }
      .flex-col-wrap {
        display: flex;
        flex-direction: column;

        align-items: center;
        gap: 8px;
        min-width: 92px;
        p {
          font-size: 20px;
          font-weight: bold;
          cursor: default;
        }
      }
    }
    .kakao-wrap {
      padding: 32px 24px;
      border: 1px solid #a5a5a5;
      border-radius: 16px;
      display: flex;
      flex-direction: column;
      gap: 24px;
      .location-text-wrap {
        display: flex;
        justify-content: space-between;
        span {
          color: rgb(92, 91, 91);
          font-weight: normal;
          font-size: 20px;
        }
        > p {
          font-weight: bold;
          color: #171717;
          font-size: 24px;
          line-height: 1.3;
          text-align: left;
        }
        .location-icon-wrap {
          display: flex;
          gap: 12px;
          a,
          button {
            &.mobile-button {
              display: none;
            }
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 0 none;
            width: 64px;
            height: 64px;
            border-radius: 32px;
            background: #efefef;
            > img {
              width: 34px;
              height: 34px;
            }
          }
        }
      }
      .kakao-button-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        background-color: #fee500;
        border-radius: 50px;
        width: 100%;
        height: 52px;
        color: #242424;
        > img {
          width: 20px;
          height: 20px;
        }
        p {
          color: #242424;
          font-weight: bold;
          font-size: 20px;
          line-height: 1.4;
        }
      }
    }
  }
  @media all and (max-width: 1024px) {
    gap: 42px;
  }
  @media all and (max-width: 900px) {
    .img-wrap {
      width: 260px;
    }
  }
  @media all and (max-width: 768px) {
    flex-direction: column;
    gap: 3.125vw;
    .img-wrap {
      width: 39.063vw;
      margin: 0 auto;
    }
    .info-wrap {
      padding-top: 0;
      .title-wrap {
        gap: 1.563vw;
        align-items: center;
        margin-bottom: 2.604vw;
        p {
          text-align: center;
          font-size: 5.208vw;
        }
        h6 {
          text-align: center;
          font-size: 6.25vw;
        }
      }
      .icon-wrap {
        gap: 2.604vw;
        margin-bottom: 8.333vw;
        justify-content: center;
        a {
          width: 10.677vw;
          height: 10.677vw;
          border-radius: 5.339vw;
          img {
            width: 5.99vw;
            height: 5.99vw;
          }
        }
        .flex-col-wrap {
          gap: 1.823vw;
          min-width: 15.625vw;
          p {
            font-size: 3.385vw;
          }
        }
      }
      .kakao-wrap {
        padding: 5.208vw 3.646vw;
        border-radius: 2.604vw;
        gap: 3.125vw;
        .location-text-wrap {
          flex-direction: column;
          gap: 2.083vw;
          > p {
            font-size: 3.906vw;
          }
          .location-icon-wrap {
            gap: 2.083vw;
            a,
            button {
              width: 10.677vw;
              height: 10.677vw;
              border-radius: 5.339vw;
              &.pc-button {
                display: none;
              }
              &.mobile-button {
                display: flex;
              }
              > img {
                width: 5.99vw;
                height: 5.99vw;
              }
            }
          }
        }
        .kakao-button-wrap {
          gap: 1.563vw;

          border-radius: 6.51vw;
          width: 100%;
          height: 9.115vw;
          > img {
            width: 3.906vw;
            height: 3.906vw;
          }
          p {
            font-size: 3.906vw;
          }
        }
      }
    }
  }
`;
